export default "__VITE_ASSET__LbPxU$E0__"